import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetDelecteConnectPromotion(club, idConnection) {
  var url =
    "/reservation/delete_promotion_connection/" + club + "/" + idConnection;

  return FetchGetDataWithAuthNEW(url);
}
